import { GlobalCSS } from "./Utils/styles";
import { Swarm } from "./Components/Background";
import { Canvas } from "@react-three/fiber";
import _react, { useCallback, useRef } from "react";
import { FullView } from "./Utils/styles";
import App from "./Components/App";


export default function Main() {
    const mouse = useRef([0, 0])
    const onMouseMove = useCallback(({ clientX: x, clientY: y }) => (mouse.current = [x - window.innerWidth / 2, y - window.innerHeight / 2]), []);

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return <>
        <GlobalCSS />
        <FullView>
            <Canvas
                pixelRatio={Math.min(2, isMobile ? window.devicePixelRatio : 1)}
                camera={{ fov: 100, position: [0, -10, 30] }}
                onMouseMove={onMouseMove}
            >
                <fog attach="fog" args={['white', 50, 190]} />

                <Swarm count={isMobile ? 1500 : 3000} mouse={mouse} />
            </Canvas>
        </FullView>
        <App />
    </>
}